import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";

const IMAGE_HINTS = {
    filasDivididas: {
        image: "Sugerencia: 800×530px (relación 3:2). Se adapta al ancho disponible con object-fit: cover.",
    },
    tarjetasAccion: {
        image: "Sugerencia: 600×400px (relación 3:2). Se recorta a un alto dinámico (140–200px) en la cabecera.",
    },
    tarjetasImagen: {
        backgroundImage: "Sugerencia: 300×300px (relación ~1:1). Fondo decorativo detrás de las tarjetas.",
        image: "Sugerencia: 400×280px (relación 10:7). Se muestra a un alto dinámico (110–160px).",
        linkUrl: "URL completa. Al hacer clic en la tarjeta se abrirá en una nueva pestaña.",
    },
    carrusel: {
        image: "Sugerencia: 1200×300px (relación 4:1). Formato horizontal, se recorta dinámicamente según el viewport.",
    },
};

const StructuredSectionEditor = ({
    section,
    sectionIndex,
    config,
    entries,
    updateSection = () => {},
    addStructuredLine = () => {},
    editStructuredLine = () => {},
    cancelEdit = () => {},
    removeStructuredLine = () => {},
    editingIndex = null,
}) => (
    <>
        {section.type === "acordeon" ? (
            <div className="admin-pages-row">
                <label>Introduccion del bloque (opcional)</label>
                <InputTextarea
                    className="admin-pages-field"
                    value={section.description || ""}
                    onChange={(event) => updateSection(sectionIndex, { description: event.target.value })}
                />
            </div>
        ) : null}
        {section.type === "tarjetasAccion" ? (
            <div className="admin-pages-row">
                <label>Texto breve</label>
                <InputTextarea
                    className="admin-pages-field"
                    value={section.description || ""}
                    onChange={(event) => updateSection(sectionIndex, { description: event.target.value })}
                />
            </div>
        ) : null}
        <div className="admin-pages-structured-editor">
            {config.fields.map((field) => (
                <div key={`${section.type}-${field.key}`} className="admin-pages-row">
                    <label>{field.label}</label>
                    {field.input === "textarea" ? (
                        <InputTextarea
                            className="admin-pages-field"
                            value={section[`draft_${field.key}`] || ""}
                            onChange={(event) => updateSection(sectionIndex, { [`draft_${field.key}`]: event.target.value })}
                            placeholder={field.placeholder || ""}
                        />
                    ) : null}
                    {field.input === "select" ? (
                        <Dropdown
                            className="admin-pages-field"
                            value={section[`draft_${field.key}`] || field.options?.[0]?.value}
                            options={field.options || []}
                            optionLabel="label"
                            optionValue="value"
                            onChange={(event) => updateSection(sectionIndex, { [`draft_${field.key}`]: event.value })}
                        />
                    ) : null}
                    {!field.input || field.input === "text" ? (
                        <InputText
                            className="admin-pages-field"
                            value={section[`draft_${field.key}`] || ""}
                            onChange={(event) => updateSection(sectionIndex, { [`draft_${field.key}`]: event.target.value })}
                            placeholder={field.placeholder || ""}
                        />
                    ) : null}
                    {IMAGE_HINTS[section.type]?.[field.key] ? (
                        <small className="admin-sidebar-hint admin-text-xs">
                            <i className="pi pi-info-circle" /> {IMAGE_HINTS[section.type][field.key]}
                        </small>
                    ) : null}
                </div>
            ))}
            <Button
                type="button"
                className="p-button-sm p-button-rounded"
                icon={editingIndex !== null ? "pi pi-check" : "pi pi-plus"}
                label={editingIndex !== null ? `Actualizar ${config.itemLabel}` : `Agregar ${config.itemLabel}`}
                onClick={() => addStructuredLine(sectionIndex, config)}
            />
            {editingIndex !== null ? (
                <Button
                    type="button"
                    className="p-button-sm p-button-rounded p-button-outlined"
                    label="Cancelar"
                    onClick={() => cancelEdit(sectionIndex, config)}
                />
            ) : null}
            <small className="admin-structured-hint">
                {editingIndex !== null
                    ? `Editando ${config.itemLabel} ${editingIndex + 1}. Modifica los campos y presiona "Actualizar".`
                    : `Completa los campos y presiona "Agregar ${config.itemLabel}" para crear cada elemento.`
                }
            </small>
        </div>
        <div className="admin-pages-structured-list">
            <label>{`${config.itemLabel.charAt(0).toUpperCase()}${config.itemLabel.slice(1)}s agregados`}</label>
            {entries.map((entry, entryIndex) => (
                <div key={`${section.type}-${entryIndex}`} className={`admin-pages-structured-item ${editingIndex === entryIndex ? "admin-pages-structured-item-editing" : ""}`}>
                    <div>
                        <strong>{entry[config.fields[0].key] || `${config.itemLabel} ${entryIndex + 1}`}</strong>
                        <p>{config.fields.slice(1).map((field) => entry[field.key]).filter(Boolean).join(" · ") || "Sin detalle adicional"}</p>
                    </div>
                    <div className="admin-pages-structured-item-actions">
                        <Button
                            type="button"
                            className="p-button-text p-button p-button-sm"
                            icon="pi pi-pencil"
                            onClick={() => editStructuredLine(sectionIndex, entryIndex, config)}
                            title={`Editar ${config.itemLabel}`}
                        />
                        <Button
                            type="button"
                            className="p-button-text p-button p-button-sm"
                            icon="pi pi-trash"
                            onClick={() => removeStructuredLine(sectionIndex, entryIndex)}
                            title={`Eliminar ${config.itemLabel}`}
                        />
                    </div>
                </div>
            ))}
            {!entries.length ? <small>No hay elementos agregados todavia.</small> : null}
        </div>
    </>
);

export default StructuredSectionEditor;
